import React from "react";
import PriceTable from "./PriceTable";

const OffsetTable = ({ items }) => {
    if (!items) {
        return null;
    }

    const headItems = items.labels;
    const bodyItems = items.prices;

    return (
        <>
           <h1
                style={{ lineHeight: "100%" }}
                className="text-3xl font-head font-bold mb-1"
            >
               Offset drukwerk
            </h1>
            <p className="mb-4">Goedkoper bij grotere oplages</p>
            <div className="w-full bg-white p-4 rounded border border-gray-200">
                <div className="mb-4">
                    <PriceTable
                        type="offset"
                        headerItems={headItems}
                        bodyItems={bodyItems}
                    />
                </div>
            </div>
        </>
    );
};

export default OffsetTable;
